// ==============================
// Словари синонимов
// ==============================
export const SYNONYMS = {
  "Колір": {
    "Бежевий": ["Беж", "бежевий", "бежеві", "бежевые"],
    "Чорний": ["Чорний", "чорний", "черный", "черные", "чорні"],
    "Білий": ["Білий", "білий", "Білі", "белые"],
    "Сірий": ["Сірий", "сірий", "серые"],
    "Шоколадний": ["Шоколадний", "шоколадні", "шоколадные", "шоколад", "Шоколад"],
    "Шоколадний питон": ["шоколадний питон"],
    "Бордовий": ["Бордо", "бордовые"],
    "Бургунді": ["Бургунді", "бургунді", "марсала"],
    "Марсала": ["Марсала", "марсала"],
    "Рожевий": [
      "Рожевий",
      "рожевий",
      "розовий",
      "розовые",
      "ніжно-рожевий",
      "Розовий"
    ],
    "Рожевий питон": ["рожевий питон"], "Синій": ["Синій", "синій"],
    "Ніжно-голубий": ["нежно-голубые", "ніжно-голубий", "ніжно-голубі"],
    "Бірюзовий": ["Бирюза", "бирюза"],
    "Жовтий": ["Жовтий"],
    "Лимонний": ["лимонний", "Лимонні", "лимонні"],
    "Лимонно-жовтий": ["лимонно-жовтий"],
    "Золотий": ["Золото"],
    "Срібний": ["Срібло"],
    "Прозорий": ["Прозорий", "Прозорий у рожевому конверті"],
    "Персиковий": ["Персик"],
    "Бежево-рожевий": ["Бежево-рожевий", "бежево-рожеві", "бежево/рожеві", "бежево-розовые"],
  },

  "Матеріал": {
    "Замша": ["замша", "suede"],
    "Шкіра": ["шкіра", "кожа", "натуральная кожа", "Натуральна шкіра"],
    "Лак": ["лак"],
  },

  "Розмір": {
    "XS": ["XS"],
    "S": ["S"],
    "M": ["M", "М"], // латиница и кириллица
    "L": ["L"],
    "XL": ["XL"],
    "2XL": ["2XL", "2Xl"],
    "3XL": ["3XL"],
  },
  "Тип підошви": {
    "Чорна гладка": [
      "Чорна гладка",
      "чорна гладка",
      "гладкая черная",
    ],
    "Чорна": ["Чорна", "чорна", "черная"],
    "Чорна замшева": [
      "Чорна замшева",
      "чорна замшева",
      "замшевая черная",
    ],
    "Чорна ребриста": ["Чорна ребриста", "чорна ребриста"],
    "Бежева гладка": [
      "Бежева гладка",
      "гладкая бежевая"
    ],
    "Гладка": ["Гладка", "гладкая"],
    "Бежева": ["Бежева", "бежевая"],
    "Бежева замшева": [
      "Бежева замшева",
      "бежева замшева",
    ],
    "Бежева ребриста": [
      "Бежева ребриста",
      "бежевая ребристая",
      "ребристая бежевая",
    ],
  },

  "Форма/висота підборів": {
    // ---- формы ----
    "Чарка": ["Чарка", "чарка", "рюмка", "Підбор Чарка 9 см", "Підбор Чарка 9 см"],
    "Прямий": ["Прямий", "прямий", "прямой"],
    // "Трикутник": ["треугольник"],

    // ---- конкретные комбинации форма+высота ----
    "Прямий підбор 8 см": ["Прямий підбор 8 см"],
    "Прямий підбор 9 см": ["Прямий підбор 9 см"],
    "Підбор трикутник 8 см": ["Підбор трикутник 8 см", "Підбор Трикутник 8 см"],

    // ---- только высота ----
    "Підбор 7 см": ["Підбор 7 см"],
    "Підбор 9 см": ["Підбор 9 см"],
    "Підбор 9.5 см": ["Підбор 9.5 см"],
    "Підбор 11 см": ["Підбор 11 см"],
  },
};

// порядок буквенных размеров
const SIZE_ORDER = ["XS", "S", "M", "L", "XL", "2XL", "3XL"];

// ==============================
// Фронт: нормализация опций
// ==============================
export function normalizeOptions(propName, options) {
  const map = SYNONYMS[propName];
  if (!map) {
    // если словаря нет → просто капитализация
    return options.map(capitalizeFirst);
  }

  const used = new Set();
  const out = [];

  // 1) Применяем словарь: заменяем все варианты на канонические
  for (const [canonical, synonyms] of Object.entries(map)) {
    if (options.some((opt) => synonyms.includes(opt) || opt === canonical)) {
      out.push(canonical);
      synonyms.forEach((s) => used.add(s));
      used.add(canonical);
    }
  }

  for (const raw of options) {
    if (used.has(raw)) continue;
    const norm = normalizeLoose(raw, propName);

    out.push(norm);
  }

  const unique = Array.from(new Set(out));

  if (propName === "Розмір") return sortSizes(unique);

  return unique.sort((a, b) => a.localeCompare(b));
}

function capitalizeFirst(s) {
  return typeof s === "string" && s.length
    ? s.charAt(0).toUpperCase() + s.slice(1)
    : s;
}

function normalizeLoose(s, propName) {
  if (typeof s !== "string") return s;
  let v = s.trim();

  v = v.replace(/\s*-\s*/g, "-");

  if (propName === "Розмір") {
    v = v.toUpperCase();
    v = v.replace("М", "M");
  } else {
    v = v.charAt(0).toUpperCase() + v.slice(1).toLowerCase();
  }

  return v;
}


function isNumberSize(s) {
  return /^\d+$/.test(s); // только цифры
}

function isRangeSize(s) {
  return /^\d+-\d+$/.test(s); // "35-39"
}

function rangeStart(s) {
  return parseInt(s.split("-")[0], 10);
}

function groupRank(s) {
  // 0: числа, 1: диапазоны, 2: буквенные, 3: остальное
  if (isNumberSize(s)) return 0;
  if (isRangeSize(s)) return 1;
  if (SIZE_ORDER.includes(s)) return 2;
  return 3;
}

function sortSizes(arr) {
  return arr.slice().sort((a, b) => {
    const ga = groupRank(a);
    const gb = groupRank(b);
    if (ga !== gb) return ga - gb;

    // сортировка внутри группы
    if (ga === 0) return parseInt(a, 10) - parseInt(b, 10); // числа
    if (ga === 1) return rangeStart(a) - rangeStart(b); // диапазоны
    if (ga === 2) return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b); // буквенные

    return a.localeCompare(b); // прочие
  });
}

export function expandSynonyms(propName, values) {
  const map = SYNONYMS[propName];
  if (!map) return values;

  const expanded = [];
  for (const val of values) {
    if (map[val]) {
      expanded.push(...map[val], val);
    } else {
      expanded.push(val);
    }
  }
  return expanded;
}
